import React from "react";
import { CloseIcon } from "../../icons";
import styles from "./toast.module.scss";
const CloseButton = ({ closeToast, onClick, disabled, label = "Close", }) => (React.createElement("button", { type: "button", "aria-label": label, className: styles.close, disabled: disabled, onClick: onClick !== null && onClick !== void 0 ? onClick : closeToast },
    React.createElement(CloseIcon, { size: "sm" })));
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map